const BASE_URL = "https://pdf-management.vercel.app";
// const BASE_URL = "https://pdfmanagementmern.onrender.com";
export default BASE_URL;
